module.exports = __webpack_public_path__ + "fa2360ce30e17566bf387bc88b07fe61.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/satzung.jpg
// module id = 638
// module chunks = 0